import { Navigate } from "react-router-dom";
import { eNums } from "../../constants";
import cookieStorage from "../../utilities/cookie_storage";

function ProtectedRoute({ children, allowedUserTypes }) {
  const token = cookieStorage.getItem("token");
  const userType = cookieStorage.getItem('userType');
  const lastLoggedInAt = cookieStorage.getItem("lastLoggedInAt");
  const roleName = cookieStorage.getItem("roleName");
  const userCategory = cookieStorage.getItem("userCategory");
  const businessType = cookieStorage.getItem("businessType");

  if (!token) {
    return <Navigate to={`/${userType?.includes(eNums?.AGENT) ? 'agent/' : ''}signin`} replace />;
  }
  if (allowedUserTypes && !(allowedUserTypes?.includes(userType))) {
    if (!lastLoggedInAt && roleName?.toLowerCase()?.includes('employee')) {
      return <Navigate to={`/onboarding`} replace />;
    }
    if (userType?.includes(eNums?.CLIENT) && !(userCategory || businessType)) {
      return <Navigate to="/client-onboarding" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  if (!lastLoggedInAt && roleName?.toLowerCase()?.includes('employee')) {
    return <Navigate to={`/onboarding`} replace />;
  }
  if (userType?.includes(eNums?.CLIENT) && !(userCategory || businessType)) {
    return <Navigate to="/client-onboarding" replace />;
  }

  return children;
}

export default ProtectedRoute;
